import configFile from '../aws-exports.json';

export const getTenantRegion = () => {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('tenant-region') : null;
    if (!raw || raw === 'null' || raw === 'undefined') {
      return configFile.aws_project_region || 'eu-central-1';
    }
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'string' && parsed) return parsed;
    } catch (_) {
      if (typeof raw === 'string' && raw) return raw;
    }
    return configFile.aws_project_region || 'eu-central-1';
  } catch (_) {
    return configFile.aws_project_region || 'eu-central-1';
  }
};
